import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("dropdown-menu__dropdownstyles-0dcdnu", {
  display: "flex",
  height: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "4px 8px",
  textAlign: "left",
  backgroundColor: "var(--system-white)",
  fontSize: 13,
  lineHeight: 1,
  borderRadius: "3px",
  gap: 6,
  position: "relative",
  userSelect: "none",
  transition: "0.2s",
  "&[data-disabled]": {
    pointerEvents: "none"
  },
  "&:hover": {
    backgroundColor: "var(--system-grey-50)"
  },
  "&[data-state=\"open\"]": {
    backgroundColor: "var(--system-grey-100)"
  }
});
const _staticStyles2 = _cssRef("dropdown-menu__el-360dtb", {
  zIndex: 100,
  backgroundColor: "white",
  borderRadius: 6,
  boxShadow: "0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)",
  animationDuration: "400ms",
  animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  willChange: "transform, opacity",
  "&[data-state=\"open\"]": {
    "&[data-side=\"top\"]": {
      animationName: "static-styles-dropdown-menu-kf-1yp4olgn"
    },
    "&[data-side=\"right\"]": {
      animationName: "static-styles-dropdown-menu-kf-35khf2zu"
    },
    "&[data-side=\"bottom\"]": {
      animationName: "static-styles-dropdown-menu-kf-0ephup5b"
    },
    "&[data-side=\"left\"]": {
      animationName: "static-styles-dropdown-menu-kf-0w4tvkrp"
    }
  }
});
const _staticStyles3 = _cssRef("dropdown-menu__el-0rjhez", {
  height: 1,
  backgroundColor: "#eee",
  margin: 5
});
const _staticStyles4 = _cssRef("dropdown-menu__el-2e2bdc", {
  fontSize: 13,
  lineHeight: 1,
  borderRadius: 3,
  display: "flex",
  alignItems: "center",
  height: 25,
  padding: "0 5px",
  position: "relative",
  paddingLeft: 25,
  paddingRight: 35,
  userSelect: "none",
  "&[data-disabled]": {
    pointerEvents: "none"
  },
  "&[data-highlighted]": {
    backgroundColor: "#eee"
  }
});
const _staticStyles5 = _cssRef("dropdown-menu__el-1ihqnk", {
  fontSize: 13,
  lineHeight: 1,
  borderRadius: 3,
  display: "flex",
  alignItems: "center",
  height: 25,
  padding: "0 5px",
  position: "relative",
  paddingLeft: 25,
  paddingRight: 35,
  userSelect: "none",
  "&[data-disabled]": {
    pointerEvents: "none"
  },
  "&[data-highlighted]": {
    backgroundColor: "#eee"
  },
  "& .DropdownMenuItemIndicator": {
    backgroundColor: "var(--primary-orange-500)",
    borderRadius: "3px",
    color: "var(--system-white)"
  }
});
import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { borderRadius } from '../tokens';
import { colors } from '../colors';
import CheckIcon from '../../../images/check-icon.svg';
export interface DropdownProps extends Omit<HtmlPropsNoRef<DropdownMenu.DropdownMenuTriggerProps>, 'onChange' | 'onBlur' | 'title'> {
  children: React.ReactNode | React.ReactNode[];
  title: React.ReactNode | string;
  align?: 'start' | 'center' | 'end';
  dropdownProps?: {
    root?: DropdownMenu.DropdownMenuProps;
    trigger?: DropdownMenu.DropdownMenuTriggerProps & React.RefAttributes<HTMLButtonElement>;
    portal?: DropdownMenu.DropdownMenuPortalProps;
    content?: DropdownMenu.DropdownMenuContentProps & React.RefAttributes<HTMLDivElement>;
  };
}
const slideUpAndFade = "static-styles-dropdown-menu-kf-0ephup5b";
const slideRightAndFade = "static-styles-dropdown-menu-kf-0w4tvkrp";
const slideDownAndFade = "static-styles-dropdown-menu-kf-1yp4olgn";
const slideLeftAndFade = "static-styles-dropdown-menu-kf-35khf2zu";
export const dropdownStyles = _staticStyles;
const Dropdown = ({
  title,
  children,
  name,
  disabled,
  className,
  align = 'center',
  dropdownProps = {
    root: {},
    trigger: {},
    portal: {},
    content: {}
  }
}: DropdownProps): JSX.Element => <DropdownMenu.Root {..._mergeExternalProps(dropdownProps.root)}>
        <DropdownMenu.Trigger {..._mergeExternalProps({
    css: dropdownStyles,
    className: className,
    "aria-label": name,
    disabled: disabled,
    "aria-disabled": disabled
  }, dropdownProps.trigger)}>
            {title}
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal {..._mergeExternalProps(dropdownProps.portal)}>
            <DropdownMenu.Content {..._mergeExternalProps({
      align: align,
      sideOffset: 5,
      css: _staticStyles2
    }, dropdownProps.content)}>
                {children}
            </DropdownMenu.Content>
        </DropdownMenu.Portal>
    </DropdownMenu.Root>;
export const DropdownSeparator = (props: DropdownMenu.DropdownMenuSeparatorProps): JSX.Element => <DropdownMenu.DropdownMenuSeparator {..._mergeExternalProps({
  css: _staticStyles3
}, props)} />;
export const DropdownItem = (props: DropdownMenu.DropdownMenuItemProps): JSX.Element => <DropdownMenu.Item {..._mergeExternalProps({
  css: _staticStyles4
}, props)} />;
export const CheckboxItem = ({
  children,
  ...props
}: DropdownMenu.DropdownMenuCheckboxItemProps): JSX.Element => <DropdownMenu.CheckboxItem {..._mergeExternalProps({
  css: _staticStyles5
}, props)}>
        {children}
        <DropdownMenu.ItemIndicator className="DropdownMenuItemIndicator">
            <CheckIcon aria-hidden="true" focusable="false" />
        </DropdownMenu.ItemIndicator>
    </DropdownMenu.CheckboxItem>;
export default Dropdown;